import "./i18n";

import * as serviceWorker from "./serviceWorker";

import { BrowserRouter, HashRouter as Router } from "react-router-dom";

import App from "./App";
import NetworkService from "./helpers/api_helper";
import { Provider } from "react-redux";
import React from "react";
import ReactDOM from "react-dom";
import { createHashHistory } from 'history';
import store from "./store";

const history = createHashHistory();
NetworkService.setupInterceptors(store,history);
const app = (
  <Provider store={store}>
    <BrowserRouter>
      <Router history={history}>
        <App />
      </Router>
    </BrowserRouter>
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));
serviceWorker.unregister();
